import { FetchError } from '@medusajs/js-sdk';

export function medusaErrorStatus(error: unknown): number | undefined {
  if (error instanceof FetchError) {
    return error.status;
  }

  if (typeof error === 'object' && error !== null) {
    const candidate = error as {
      status?: unknown;
      statusCode?: unknown;
      response?: { status?: unknown };
    };
    const status = candidate.status ?? candidate.statusCode;
    if (typeof status === 'number') {
      return status;
    }

    const responseStatus = candidate.response?.status;
    if (typeof responseStatus === 'number') {
      return responseStatus;
    }
  }

  return undefined;
}

export function isUnauthorizedMedusaError(error: unknown): boolean {
  return medusaErrorStatus(error) === 401;
}

export function normalizeMedusaError(
  error: unknown,
  action: 'login' | 'register' | 'profile' | 'address' | 'password',
): string {
  const status = medusaErrorStatus(error);

  if (action === 'login') {
    return status === 401
      ? 'The email or password you entered is incorrect.'
      : 'We could not sign you in right now. Please try again.';
  }

  if (action === 'register') {
    return status === 401 || status === 409 || status === 422
      ? 'We could not create this account. Try signing in if the email is already registered.'
      : 'We could not create your account right now. Please try again.';
  }

  if (action === 'password') {
    return status === 401
      ? 'Your current password is incorrect.'
      : 'We could not update your password right now. Please try again.';
  }

  if (action === 'address') {
    return 'We could not save this address. Please check the details and try again.';
  }

  return 'We could not save these details right now. Please try again.';
}
